import { Epic, combineEpics } from 'redux-observable';
import { isOfType, action } from 'typesafe-actions';
import { filter, mergeMap, catchError } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { push } from 'connected-react-router';
import { toastr } from 'react-redux-toastr';
import moment from "moment";

import { IRootAction } from 'reducers';
import { ActionTypes } from 'reducers/user';
import { ActionTypes as appActions } from 'reducers/app';
import { ActionTypes as cartActions } from 'reducers/cart';

import * as userAPI from 'api/regRequest';

const login: Epic<IRootAction, any> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(ActionTypes.PERFORM_LOGIN)),
    mergeMap<any, any>(({ payload }) =>
      from(userAPI.login(payload.values)).pipe(
        mergeMap<any, any>((response: any) => {
          if (response.success) {
            const refEndDate = moment(response.user.ref_end_date).utc().format('YYYY-MM-DD');
            const todayDate = moment(new Date()).format('YYYY-MM-DD');
            if (moment(refEndDate).utc().isAfter(todayDate)) {
              toastr.success(`У вас действует повышенный процент ещё ${moment(response.user.ref_end_date).diff(moment(new Date()), 'days') } дней`, '');
            }
            payload.setSubmitting(false);
            return of(
              // action(appActions.TOGGLE_BLOCKING_UI, false),
              action(cartActions.FETCH_CART_SUCCESS, response.user.cart),
              action(ActionTypes.PERFORM_LOGIN_SUCCESS, response.user),
              push(response.user.view_intro ? '/home/dashboard' : '/intro'),
            );
          }
          payload.setSubmitting(false);
          payload.setStatus('Ошибка. Не удалось авторизоваться');
          toastr.error('Проверьте правильность ввода логина и пароля', '');
          return of(
            action(appActions.TOGGLE_BLOCKING_UI, false),
            action(ActionTypes.PERFORM_LOGIN_FAILURE),
          );
        }),
        catchError(error => of(`Error: ${error}`, action(appActions.TOGGLE_BLOCKING_UI, false)))
      )
    ),
  );

const checkStatus: Epic<IRootAction, any> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(ActionTypes.IS_LOGINED_REQUEST)),
    mergeMap<any, any>(() =>
      from(userAPI.checkLogin()).pipe(
        mergeMap<any, any>(({ isLogined, user }: any) => {
          if (isLogined) {
            const refEndDate = moment(user.ref_end_date).utc().format('YYYY-MM-DD');
            const todayDate = moment(new Date()).format('YYYY-MM-DD');
            if (moment(refEndDate).utc().isAfter(todayDate)) {
              toastr.success(`У вас действует повышенный процент ещё ${moment(user.ref_end_date).diff(moment(new Date()), 'days') } дней`, '');
            }
            return of(
              action(cartActions.FETCH_CART_SUCCESS, user.cart),
              action(ActionTypes.IS_LOGINED, { isLogined, user }),
              // action(NewsActions.FETCH_NEWS_REQUEST),
            );
          }
          // toastr.error('Вы не авторизованы. Выполните вход', '');
          return of(
            action(ActionTypes.IS_LOGINED, { isLogined, user }),
            push('/auth'),
          );
        }),
      )
    )
  );

const logout: Epic<IRootAction, any> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(ActionTypes.LOGOUT)),
    mergeMap<any, any>(() =>
      from(userAPI.logout()).pipe(
        mergeMap<any, any>(({ success }: any) => {
          if (success) {
            toastr.success('Выход из системы', '');
            return of(
              action(ActionTypes.LOGOUT_SUCCESS),
              push('/auth'),
            );
          }
          toastr.error('Ошибка выхода из системы', '');
          return of(action(ActionTypes.LOGOUT_FAILURE));
        }),
      )
    )
  );

// const restorePassword: Epic<IRootAction, any> = (action$, state$) =>
//   action$.pipe(
//     filter(isOfType(ActionTypes.RESTORE_PASSWORD_REQUEST)),
//     mergeMap<any, any>(({ payload }) =>
//       from(userAPI.restorePassword(payload)).pipe(
//         mergeMap<any, any>((response: any) => {
//           if (response.success) {
//             toastr.success('Новый пароль отправлен на E-mail', '');
//             return of(
//               action(appActions.TOGGLE_BLOCKING_UI, false),
//               push('/auth'),
//             );
//           }
//           toastr.error(response.error, '');
//           return of(
//             action(appActions.TOGGLE_BLOCKING_UI, false),
//             action(ActionTypes.RESTORE_PASSWORD_FAILURE),
//           );
//         }),
//         catchError(error => of(`Error: ${error}`, action(appActions.TOGGLE_BLOCKING_UI, false)))
//       )
//     ),
//   );

const updateUser: Epic<IRootAction, any> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(ActionTypes.PROFILE_UPDATE)),
    mergeMap<any, any>(({ payload }) =>
      from(userAPI.updateUserProfile(payload.values)).pipe(
        mergeMap<any, any>((response: any) => {
          if (response.success) {
            payload.setSubmitting(false);
            payload.toggleEditProfile();
            return of(
              // action(appActions.TOGGLE_BLOCKING_UI, false),
              action(ActionTypes.PROFILE_UPDATE_SUCCESS, { ...payload.values, photo: response.data.photo }),
            );
          }
          toastr.error(response.error, '');
          payload.setSubmitting(false);
          return of(
            action(appActions.TOGGLE_BLOCKING_UI, false),
          );
        }),
        catchError(error => {
          payload.setSubmitting(false);
          return of(`Error: ${error}`, action(appActions.TOGGLE_BLOCKING_UI, false))
        })
      )
    ),
  );

export default combineEpics(
  login,
  checkStatus,
  logout,
  // restorePassword,
  updateUser,
);
